<template>
  <div class="ch-component-warpper">
    <div class="ch-component">
      <v-container fluid grid-list-lg class="ch-menu-wrapper">
        <div class="ch-menu-title">
          <span class="ch-component-title pl-2">AUDIT LOG</span>
        </div>
        <div class="filter-body-wrapper">
          <audit-logs-filter :storeFilter="storeFilter"></audit-logs-filter>
        </div>
      </v-container>
      <v-container fluid grid-list-lg class="pt-4">
        <audit-logs-list :storeFilter="storeFilter" :storePage="storePage"></audit-logs-list>
      </v-container>
    </div>
  </div>
</template>

<script>
  import { navigationEventBus } from '@/components/navigation/navigationEventBus';
  import { auditLogsEventBus } from '@/components/admin/auditLogs/auditLogsEventBus';
  import AuditLogsFilter from '@/components/admin/auditLogs/AuditLogsFilter';
  import AuditLogsList from '@/components/admin/auditLogs/AuditLogsList';
  import ScrollEvent from '@/components/customized-components/ScrollEvent';

  export default {
    props: ['storeFilter', 'storePage'],
    data() {
      return {
        navigationDrawer: true,
      };
    },
    methods: {
      // NOTE: clear form
      clearForm() {
        this.dialog = false;
        auditLogsEventBus.$emit('clearForm');
      },
      // NOTE: toogle navigation drawer
      toogleDrawer() {
        navigationEventBus.$emit('toogle');
      },
      openDialog() {
        auditLogsEventBus.$emit('openDialog');
      },
    },
    mounted() {
      navigationEventBus.$on('ondrawerHide', () => {
        this.navigationDrawer = false;
      });
      navigationEventBus.$on('ondrawerShow', () => {
        this.navigationDrawer = true;
      });
    },
    components: {
      AuditLogsFilter, AuditLogsList, ScrollEvent,
    },
  };
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/admin/AuditLogs.vue